import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import React from 'react';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import '../reset.css';
import styles from './style.css';
import Header from './header';
import Navigation from './nav';
import ContentRight from './contentRight';
import ContentLeft from './contentLeft';

import BottomFooter from './footer';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;

        // console.log('index.jsx content----', content);

        // 头部
        const headerData = {
            nav: content.nav,
            search: content.search,
            logo: content.logo,
        };

        // banner+导航
        const navData = {
            banner: content.banner,
            navigation: content.navigation,
        };

        // 页面右侧
        const contentRightData = {
            market: content.market,
            courier: content.courier,
        };

        // 页面左侧信息流
        const contentLeftData = {
            newsstream: content.newsstream,
            columnId: content.columnId,
            isEnd: content.isEnd,
        };

        return (
            <div>
                <Header content={headerData} />

                <Navigation content={navData} />

                <div className={`${styles.w1000} clearfix`}>
                    <ContentLeft content={contentLeftData} />
                    <ContentRight content={contentRightData} />
                </div>

                <BottomFooter content={content.footer} />

                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
